const INDICES_RANGE = [
    { code: '5910', max: 20 },
    { code: '7613', max: 1 },
    { code: '5856', max: 20 },
    { code: '2928', max: 20 },
    { code: '7036', max: 0, min: 150, inverted: true },
    { code: '7939', max: 1 },
    { code: '1022', max: 20 },
    { code: '8058', max: 1 },
    { code: '8049', max: 1 },
    { code: '7614', max: 1 },
    { code: '6951', max: 20 },
    { code: '5909', max: 20 },
    { code: '5908', max: 20 },
    { code: '5911', max: 20 },
    { code: '5912', max: 20 },
    { code: '8973', max: 20 },
    { code: '8969', max: 20 },
    { code: '1000', max: 20 },
    { code: '1017', max: 1 },
    { code: '9025', max: 1 },
    { code: '8562', max: 1 },
    { code: '8040', max: 20 },
    { code: '8053', max: 20 },

    { code: '8062', max: 20 },
    { code: '8295', max: 15 },
    { code: '8296', max: 40 },

    { code: '6035', max: 9 },
    { code: '6959', max: 9 },
    { code: '1002', max: 9 },
    { code: '1080', max: 20 },
    // { code: '7644', max: 1 },
    // { code: '7743', max: 1 },
    // { code: '7744', max: 1 },
    // { code: '7745', max: 1 },
    // { code: '7746', max: 1 },
    // { code: '7787', max: 1 },
    // { code: '7786', max: 1 },
    { code: '8057', max: 1 },
    { code: '8054', max: 1 },
    { code: '8056', max: 1 },
    { code: '8055', max: 1 },
    { code: '8063', max: 20 },
    // { code: '8050', max: ? },
    // { code: '7974', max: ? },
    // { code: '8498', max: ? },
    // { code: '6034', max: ? },
    // { code: '8051', max: ? },
    // { code: '8130', max: ? },
    // { code: '6955', max: ? },
    // { code: '8060', max: ? },
    // { code: '8059', max: ? },
    // { code: '1001', max: ? },


    { code: '20001', max: 1 },
    { code: '20002', max: 1 },
    { code: '20003', max: 1 },
    { code: '20004', max: 1 },
    { code: '20005', max: 1 },
    { code: '20006', max: 1 },
    { code: '20007', max: 1 },
    { code: '20008', max: 1 },
    { code: '20009', max: 1 },
    { code: '20010', max: 1 },
    { code: '20011', max: 1 },
    { code: '20012', max: 1 },
]

module.exports = {
    SPECIFIC_SUPPORT_CODES: ['10'],

    INDICES_RANGE,
    LIST_INDEXES: INDICES_RANGE.map(i => i.code),
    DEFAULT_INDEXES: ['5910', '7613', '5856', '2928', '7036', '7939'],

    LIST_PRESSURES: ['20001', '20002', '20003', '20004', '20005', '20006', '20007', '20008', '20009', '20010', '20011', '20012'],
    CHEMICAL_PRESSURES: ['20001', '20002', '20003', '20004', '20005', '20006'],
    ANTHROPOGENIC_PRESSURES: ['20007', '20008', '20009', '20010', '20011', '20012'],
}